import { createSlice } from '@reduxjs/toolkit';
import {
  InitStateErrorWorkflow,
  VerificationProcesses,
  VerificationSteps,
} from './IdentityVerification.constants';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
  process: VerificationProcesses.CRYPTO_SIGNATURE_CREATION,
  step: VerificationSteps.WELCOME,
  idTypes: [],
  docsToSign: [],
  idTypeSelected: null,
  idTypeSelectedHasMrz: false,
  idTypeSelectedSubType: '',
  frontIdImageData: null,
  backIdImageData: null,
  selfieImageData: null,
  verificationId: null,
  idWorkflowActiveStep: 0,
  useLiveness: false,
  error: InitStateErrorWorkflow,
};

const identityVerificationSlice = createSlice({
  name: 'identityVerification',
  initialState,
  reducers: {
    setIdentityVerificationState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetIdentityVerificationState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const { setIdentityVerificationState, resetIdentityVerificationState } =
  identityVerificationSlice.actions;

export default identityVerificationSlice.reducer;
